import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")!

  return (_openBlock(), _createBlock(_component_ArrowIcon, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
    class: "go-back_btn"
  }))
}